import React, { useState } from 'react'
import { useHistory, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Card, CardBody, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import MainLayout from '../layouts/MainLayout';
import useQuery from '../hooks/useQuery';
import useInterval from '../hooks/useInterval';
import { useAuth } from '../context/auth';

function productsParser(product) {
  if (product.includes('10_contracts_level_1')) {
    return '10 Documentos Blindaje 1'
  } else if (product.includes('50_contracts_level_1')) {
    return '50 Documentos Blindaje 1'
  }
}

function SuccessPurchasePage() {
  const query = useQuery();
  const { t } = useTranslation('common');
  const [count, setCount] = useState(15);
  const history = useHistory();
  const [auth] = useAuth();

  const goBack = () => {
    history.replace('/')
  }

  useInterval(() => {
    if (count - 1 === 0) {
      goBack()
    } else if (query.get('type') !== 'contract-sent') {
      setCount(count => count - 1)
    } 
  }, 1000)

  return (
    <MainLayout showUpgradeBanner={!!auth.hasAccount}>  
      <Container className="d-flex mvh-75">
        <Card className="align-self-center w-50 mx-auto">
          <CardBody className="text-center py-5">
            <FontAwesomeIcon className="text-green d-block mx-auto" icon="check-circle" size="6x" />
            <span className="display-5 font-weight-bold mb-0">{t('successMessages.successfullPurchase')}</span>
            <p className="text-muted mt-0">{t('successMessages.thanksForPurchase')}<br /> <strong>{query.get('productName')}</strong></p> {/*{productsParser(query.get('productId'))}*/}
            { query.get('type') === 'contract-sent' ?  
              <div className="font-size-20">¡Tu documento ha sido enviado por correo electrónico!</div>
              : <small className="text-dark"> {t('redirectInSeconds',  {count})} </small>
            }
            <div hidden={query.get('goToMyTemplates') !== 'true'}>
              <Button tag={Link} to={`/templates/own`} color="accent-100" className="mt-2">{t('Ir a mis plantillas')}</Button>
            </div>
            <div hidden={!auth.hasAccount || query.get('goToMyDocuments') !== 'true'}>
              <Button tag={Link} to={`/documents/own`} color="accent-100" className="mt-2">{t('Ir a mis documentos')}</Button>
            </div>
          </CardBody>
        </Card>
      </Container>
    </MainLayout>
  )
}

export default SuccessPurchasePage

